import http from "../http-common";

const getLoanProducts = () => {
    return http.get("/get-loan-products");
};

const createLoan = data => {
    const payload = {
        'fname' :  data.fname,
        'lname' : data.lname,
        'email' : data.email,
        'mobile' : data.mobile,
        'amount' : data.amount,
        'duration' : data.duration,
        'loanType' : data.loanType 
    };
    return http.post("/apply-loan", payload);
};

const LoanService = {
  getLoanProducts,
  createLoan,
};

export default LoanService;
